import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import Icon from 'components/Icon'
import messages from './messages'

const Th = ({ children, className = '' }) => (
  <th scope="col" className={`whitespace-nowrap sticky top-0 bg-gray-50 px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium text-gray-600 uppercase tracking-wider text-left ${className}`}>
    { children }
  </th>
)

const OrderHeadRow = ({ compact = false, sortDirection, sortBy, onSort, columns }) => {
  return (
    <tr className="whitespace-nowrap shadow sticky top-0">
      <Th className="w-24">#</Th>

      { !compact &&
        <Th className="w-24">
          <FormattedMessage {...messages.purchaseOrder} />
        </Th>
      }

      <th scope="col" className={`whitespace-nowrap sticky top-0 bg-gray-50 w-1/12 px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium uppercase tracking-wider text-center xl:text-left cursor-pointer hover:bg-gray-200 ${sortBy === 'crdate' ? 'text-gray-800' : ''}`} onClick={onSort('crdate')}>
        <FormattedMessage {...messages.date} />
        <Icon className="ml-1" icon={{ ASC: 'arrow-up', DESC: 'arrow-down' }[sortDirection]} />
      </th>

      <Th className="w-28">
        <FormattedMessage {...messages.expectedDelivery} />
      </Th>

      <Th className="w-1/4">
        <FormattedMessage {...messages.orderName} />
      </Th>

      <Th className="w-32">
        <div className="hidden xl:block">
          <FormattedMessage {...messages.stage} />
        </div>

        <div className="w-full xl:hidden text-center">
          <Icon icon="tasks" />
        </div>
      </Th>

      { !compact &&
        <Th><FormattedMessage {...messages.team} /></Th>
      }

      { !compact &&
        <Th>
          <div className="hidden xl:block">
            <FormattedMessage {...messages.contact} />
          </div>

          <div className="w-full xl:hidden text-center">
            <Icon icon="user" />
          </div>
        </Th>
      }
      
      { !compact &&
        <Th><FormattedMessage {...messages.usageRights} /></Th>
      }

      { columns.map(({ key })  => (
        <Th key={key}>
          <div className="hidden xl:block">
            { key.replace('_', ' ') }
          </div>
          <div className="xl:hidden" title={key.replace('_', ' ')}>
            { key.split('_').map((word) => word[0]).join('.') }
          </div>
        </Th>
      )) }

      <Th />
    </tr>
  )
}

export default OrderHeadRow
